<ng-container *ngIf="isCreateMode() || isUpdateMode() || isCustomMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header
      [mode]="mode"
      createLabel="Ajouter un ID énergie"
      customLabel="Ajouter un ID énergie"
      updateLabel="Modifier un ID énergie"
    ></base-form-header>

    <mat-dialog-content fxLayout="column">
      <base-form-input
        label="Type d'énergie"
        type="autocomplete"
        [items$]="genericEnergyIds$"
        (autocompleteChange)="genericEnergyIdsAutoCompleteChange($event)"
        displayProperty="energyType"
        controlName="genericEnergyId"
      ></base-form-input>

      <mat-form-field class="full-width">
        <mat-label>{{ customFieldLabel }}</mat-label>
        <mat-error *ngIf="energyIdIdCustomError && !isIDEnergyAlreayExist">
          {{ energyIdIdCustomError }}
        </mat-error>
        <mat-error *ngIf="isIDEnergyAlreayExist">
          {{ energyIdIdCustomError }}
        </mat-error>
        <input matInput formControlName="energyIdId" />
      </mat-form-field>

      <base-form-input
        *ngIf="!isCustomMode()"
        (autocompleteChange)="autocompleteBuildingsSearch($event)"
        [items$]="getItems$('buildings')"
        [selectedItems]="form.get('buildings').value"
        [initializedData]="form.get('buildings').value"
        (onScroll)="onScrollLine($event, 'buildings')"
        controlName="buildings"
        displayProperty="label"
        label="Bâtiment(s)"
        type="search-multiple"
        (onSelectItems)="onSelectBuildings($event)"
        [formGroup]="form"
      ></base-form-input>

      <base-form-input
        *ngIf="!isCustomMode() && establishmentsOfBuilding?.length"
        [items]="establishmentsOfBuilding"
        [isStaticData]="true"
        [selectedItems]="form.get('establishments').value"
        [initializedData]="form.get('establishments').value"
        controlName="establishments"
        displayProperty="label"
        label="Établissement(s)"
        type="search-multiple"
      ></base-form-input>

      <base-form-input
        *ngIf="isCustomMode()"
        controlName="buildings"
        displayProperty="label"
        label="Bâtiment(s) *"
        type="autocomplete"
      ></base-form-input>

      <mat-form-field
        *ngIf="isCustomMode() && form.get('establishments').value && form.get('establishments').value.length > 0"
        class="example-chip-list"
        appearance="fill"
      >
        <mat-label>Établissement(s)</mat-label>
        <mat-chip-list aria-label="Établissement(s)">
          <mat-chip
            formControlName="establishments"
            *ngFor="let establishment of form.get('establishments').value"
            [disabled]="false"
          >
            {{ establishment.label }}
          </mat-chip>
        </mat-chip-list>
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Information complémentaire</mat-label>
        <mat-error *ngIf="form.get('additionalInfo')?.hasError('maxlength')">Maximum 50 caractères</mat-error>
        <input matInput formControlName="additionalInfo" maxlength="50" />
        <mat-hint align="end">{{ form.get('additionalInfo')?.value?.length || 0 }}/50</mat-hint>
      </mat-form-field>

      <base-form-input
        label="Fournisseur"
        type="autocomplete"
        [items$]="suppliers$"
        (autocompleteChange)="autoCompleteSupplier($event)"
        displayProperty="label"
        controlName="supplier"
      ></base-form-input>

      <base-form-input
        label="Bâtiment gestionnaire"
        type="autocomplete"
        [items]="favoriteBuildings"
        [disabled]="isCustomMode()"
        (autocompleteChange)="genericBuildingsAutoCompleteChange($event)"
        displayProperty="label"
        controlName="favoriteBuilding"
      ></base-form-input>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [mode]="mode"
        entityLabel="ENERGY_ID"
        (onCreate)="createItem()"
        (onCustom)="createItem()"
        (onUpdate)="updateItem()"
        [loading]="loading"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="isArchiveMode()">
  <form-modal-delete-base
    (onClose)="close()"
    (onDelete)="archiveItem()"
    title="Archiver l'ID énergie"
    defaultMessage="Êtes-vous sûr de vouloir archiver cet ID énergie ?"
  ></form-modal-delete-base>
</ng-container>

<ng-container *ngIf="isImportMode()">
  <vex-form-import-base
    [modalTitle]="'Importer des ID Energie'"
    [entityLabel]="'ID Energie'"
    [form]="importForm"
    [loading]="loading"
    [service]="service"
    [mode]="mode"
    (saveForm)="save()"
    (importItems)="importItems()"
    [canDownloadTemplateModel]="canDownloadTemplateModel"
  ></vex-form-import-base>
</ng-container>
